/** Stroke icons on a 20 px grid, one style everywhere (design system): no icon font, no emoji. */
const PATHS = {
  home: 'M3 9.5 10 4l7 5.5V16a1 1 0 0 1-1 1h-4v-5H8v5H4a1 1 0 0 1-1-1V9.5Z',
  briefcase:
    'M3 7.5A1.5 1.5 0 0 1 4.5 6h11A1.5 1.5 0 0 1 17 7.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5v-7ZM7 6V4.5A1.5 1.5 0 0 1 8.5 3h3A1.5 1.5 0 0 1 13 4.5V6M3 10h14',
  ticket:
    'M3 7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1.5a1.5 1.5 0 0 0 0 3V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.5a1.5 1.5 0 0 0 0-3V7ZM8 6v8',
  tasks:
    'M3.5 5A1.5 1.5 0 0 1 5 3.5h10A1.5 1.5 0 0 1 16.5 5v10a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 15V5Zm3 5 2.5 2.5 4.5-5',
  inbox: 'M3 11h4l1.5 2h3L13 11h4M4.5 5h11l1.5 6v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4l1.5-6Z',
  clock: 'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm0 3v4l2.5 1.5',
  checkCircle: 'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm-3 7 2 2 4-4',
  book: 'M4 4.5A1.5 1.5 0 0 1 5.5 3H16v12H5.5A1.5 1.5 0 0 0 4 16.5v-12Zm0 12A1.5 1.5 0 0 1 5.5 15H16v2',
  box: 'm10 3 7 3.5v7L10 17l-7-3.5v-7L10 3ZM3 6.5 10 10l7-3.5M10 10v7',
  fileText: 'M5 3h7l3 3v11H5V3Zm7 0v3h3M7.5 10h5M7.5 13h5',
  tag: 'M3 4.5A1.5 1.5 0 0 1 4.5 3H10l7 7-6 6-7-7V4.5Zm4 2.5h.01',
  calendar:
    'M4 5.5A1.5 1.5 0 0 1 5.5 4h9A1.5 1.5 0 0 1 16 5.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5v-9ZM4 8h12M7 3v2M13 3v2',
  list: 'M4 5h1M8 5h8M4 10h1M8 10h8M4 15h1M8 15h8',
  receipt: 'M4 4h12v13l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5L4 17V4Zm3 4h6M7 11h4',
  chart: 'M4 16V9M9 16V4M14 16v-6M2.5 16.5h15',
  settings:
    'M10 7.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM10 3v2M10 15v2M3 10h2M15 10h2M5.05 5.05l1.4 1.4M13.55 13.55l1.4 1.4M5.05 14.95l1.4-1.4M13.55 6.45l1.4-1.4',
  shield: 'M10 3 4 5.5V10c0 3.4 2.5 6 6 7 3.5-1 6-3.6 6-7V5.5L10 3Zm-2.5 7 1.8 1.8L13 8',
  chevronLeft: 'M12 5 7 10l5 5',
  chevronRight: 'm8 5 5 5-5 5',
  chevronDown: 'm6 8 4 4 4-4',
  search: 'M9 3.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11ZM13.2 13.2 17 17',
  bell: 'M5 8a5 5 0 0 1 10 0v3l1.5 2.5h-13L5 11V8ZM8 16a2 2 0 0 0 4 0',
  user: 'M10 3.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM4 17a6 6 0 0 1 12 0',
  more: 'M5 10h.01M10 10h.01M15 10h.01',
  /** The handle a row is dragged by (`AM-297`): two columns of three dots, a little fuller than `more`'s. */
  grip: 'M6.9 5a.6.6 0 1 0 1.2 0a.6.6 0 1 0-1.2 0M11.9 5a.6.6 0 1 0 1.2 0a.6.6 0 1 0-1.2 0M6.9 10a.6.6 0 1 0 1.2 0a.6.6 0 1 0-1.2 0M11.9 10a.6.6 0 1 0 1.2 0a.6.6 0 1 0-1.2 0M6.9 15a.6.6 0 1 0 1.2 0a.6.6 0 1 0-1.2 0M11.9 15a.6.6 0 1 0 1.2 0a.6.6 0 1 0-1.2 0',
  logout: 'M8 3H4.5A1.5 1.5 0 0 0 3 4.5v11A1.5 1.5 0 0 0 4.5 17H8M12 14l4-4-4-4M16 10H7',
  activity: 'M3 10h3l2-5 4 10 2-5h3',
  plus: 'M10 4v12M4 10h12',
  x: 'm6 6 8 8M14 6l-8 8',
  arrowLeft: 'M16 10H4M9 5l-5 5 5 5',
  history: 'M4 10a6 6 0 1 1 1.76 4.24M4 10v4M4 14h4M10 6.5V10l2.5 1.5',
  link: 'M8.5 11.5a3 3 0 0 0 4.24 0l2-2a3 3 0 1 0-4.24-4.24l-1 1M11.5 8.5a3 3 0 0 0-4.24 0l-2 2a3 3 0 1 0 4.24 4.24l1-1',
  archive:
    'M3 5.5A1.5 1.5 0 0 1 4.5 4h11A1.5 1.5 0 0 1 17 5.5V7H3V5.5ZM4 7h12v7.5A1.5 1.5 0 0 1 14.5 16h-9A1.5 1.5 0 0 1 4 14.5V7Zm4 3.5h4',
  help: 'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14ZM8.2 8.4a1.9 1.9 0 1 1 2.8 1.6c-.7.4-1 .8-1 1.6M10 14h.01',
  wifiOff:
    'M3 3l14 14M4.5 8.5a11 11 0 0 1 4.24-2.4M15.5 8.5a11 11 0 0 0-2.9-2M7.2 11.8a6 6 0 0 1 3.1-1.6M12.8 11.8a6 6 0 0 0-1.2-1M10 15.5h.01',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 18,
  className,
}: {
  name: IconName;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ flex: 'none' }}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
